<template>
	<div class="welcome-main">
		<h4 class="cloumn">您目前还没有开启蓝队云 云数据库 MySQL 服务</h4>
		<p class="text">云数据库 MySQL是蓝队云提供的一款高性能、可靠稳定的云数据库产品，我们致力于为您的企业提供优质的数据库解决方案，帮助您轻松管理和扩展数据存储。</p>
		<ul>
			<li><el-text type="primary" size="small">备份和恢复：</el-text>提供定期自动备份和手动备份功能，并支持随时恢复到</li>
			<li><el-text type="primary" size="small">数据安全性：</el-text>采用严格的安全措施，包括数据加密、访问控制和身份验证等，以保护数据不受未经授权的访问和攻击</li>
			<li><el-text type="primary" size="small">管理和支持：</el-text>提供直观易用的数据库管理界面，24/7技术支持</li>
		</ul>
		<div class="agree"><el-switch v-model="agreeStatus" @change="agreeChange"></el-switch>我已经阅读并同意<a href="https://www.landui.com/docs-11955" target="_blank">《蓝队云云数据库服务协议》</a></div>
		<el-button type="primary" :disabled='disabled' @click="onsubmit">立即开通服务</el-button>
	</div>
</template>

<script setup>
	import { ref } from 'vue';
	import {useStore} from 'vuex';
	import { useRouter } from 'vue-router';
	import { setActivate } from '@/api/home';
	import { ElMessage } from 'element-plus';
	
	const store = useStore()
	const router = useRouter();
	const agreeStatus = ref(false);
	const disabled = ref(true);
	const agreeChange = (val) =>{
		agreeStatus.value = val;
		if(val){
			disabled.value = false
		}else{
			disabled.value = true
		}
	}
	const onsubmit =() =>{
		setActivate().then((res)=>{
			if(res.code === 200){
				ElMessage({
					type: 'success',
					message: res.msg,
				})
				store.commit("setActivate", 'true')
				router.push({ path: '/hosts' })
			}
		})
	}
	
</script>

<style lang="scss" scoped>
	.welcome-main{
		width: 750px;
		padding-top: 80px;
		margin: 0 auto;
		.cloumn{text-align: center; margin-bottom: 40px; font-size: 16px; font-weight: 600;}
		.text{color: #999999;line-height: 20px;overflow: hidden;}
		ul{
			margin: 20px 0;
			overflow: hidden;
			li{line-height: 24px;font-size: 12px;}
		}
		.agree{
			margin-bottom: 30px;
			overflow: hidden;
			.el-switch{margin-right: 5px;}
		}
	}
</style>